var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "list-root" },
    [
      _c("div", { staticClass: "head" }, [
        _c(
          "div",
          {
            staticClass: "folder",
            on: {
              click: function ($event) {
                return _vm.backToFolderList()
              },
            },
          },
          [
            _c("img", {
              staticClass: "folder-icon",
              attrs: { src: require("@/assets/img/icon/folder_black.png") },
            }),
          ]
        ),
        _c("div", { staticClass: "title ellipsis" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.folder
                  ? _vm.folder.name
                  : _vm.$t("worldViewPage.worldViewList.allWorldViews")
              ) +
              " "
          ),
        ]),
        _c("div", { staticClass: "edit" }, [
          !_vm.isEditing
            ? _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      _vm.isEditing = true
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("worldViewPage.worldViewList.sortButton"))
                  ),
                ]
              )
            : _c("div", { on: { click: _vm.saveOrder } }, [
                _vm._v(
                  _vm._s(_vm.$t("worldViewPage.worldViewList.saveButton"))
                ),
              ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "list-wrapper" },
        [
          _c("sortable-list", {
            ref: "listContainer",
            staticClass: "list-container",
            attrs: {
              items: _vm.items,
              keyAttr: "worldViewId",
              disabled: !_vm.isEditing,
              extra: _vm.isEditing,
            },
            on: {
              "update:items": function ($event) {
                _vm.items = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ item, extra }) {
                  return [
                    _c("list-item", {
                      attrs: {
                        icon: _vm.getWorldViewlKey(item),
                        label: item.name,
                        folderName: _vm.folderName(item),
                        iconPlaceholder: "/img/placeholders/worldview.png",
                        to: {
                          name: "worldViews",
                          params: {
                            novelId: _vm.novelId,
                            worldViewId: item.worldViewId,
                          },
                        },
                        isActive: item.worldViewId === _vm.selectedId,
                        showHandle: extra,
                        item: item,
                        customClickFunction: _vm.onClickItem.bind(
                          this,
                          item.worldViewId
                        ),
                        needsDoCustomClickFunction:
                          _vm.needsDoCustomClickFunction,
                        isEditMode: _vm.isEditing,
                      },
                      on: {
                        clickSetFolder: _vm.setFolder,
                        delete: function ($event) {
                          return _vm.deleteWorldView(item.worldViewId)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showScrollGuide,
                expression: "showScrollGuide",
              },
            ],
            staticClass: "scroll-guide",
            attrs: { "aria-hidden": "true" },
          }),
        ],
        1
      ),
      _c(
        "button-solid",
        {
          staticClass: "create",
          attrs: {
            to: {
              name: "worldViewCreate",
              params: {
                novelId: _vm.novelId,
                worldViewFolderId: _vm.folder
                  ? _vm.folder.worldViewFolderId
                  : null,
              },
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("worldViewPage.worldViewList.createNewWorldView")) +
              " "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }